import { DEFAULT_OMS_ORGAN_SPECIALIZATIONS } from '@lp/features/admin/forms/EmployeeForm/config';
import { EmployeeRole } from '@/api/apis/resources';
import { CSShiftTimeGroup } from '@/api/apis/resources/schedule';
import { EmployeeFormValues } from '@/types';

type RoleCleanupRule = {
  condition: boolean;
  fields: Partial<EmployeeFormValues>;
};

export const getRoleCleanupRules = (
  selectedRoles: EmployeeRole[],
  currentValues: EmployeeFormValues,
): RoleCleanupRule[] => {
  const hasRole = (role: EmployeeRole) => selectedRoles.includes(role);

  return [
    {
      condition: !hasRole(EmployeeRole.ClinicalSpecialist),
      fields: {
        canWorkOnExtraShifts: false,
        canTravel: false,
        extraShiftsCount: 0,
        travelShiftsCount: 0,
        clinicalSpecialistShiftGroupType: null,
        trialProgramIds: null,
      },
    },
    {
      condition: hasRole(EmployeeRole.ClinicalSpecialist) && !currentValues.shiftTimeGroup,
      fields: { shiftTimeGroup: CSShiftTimeGroup.GroupA },
    },
    {
      condition: !hasRole(EmployeeRole.RetrievalSurgeon),
      fields: {
        liverSurgeonRegionId: '',
        heartLungsSurgeonRegionId: '',
      },
    },
    {
      condition: !hasRole(EmployeeRole.ClinicalCoordinator),
      fields: { clinicalCoordinatorType: null },
    },
    {
      condition: !hasRole(EmployeeRole.ClinicalSpecialist) && !hasRole(EmployeeRole.RetrievalSurgeon),
      fields: {
        scrubSizeTop: null,
        scrubSizeBottom: null,
        weight: null,
      },
    },
    {
      condition:
        !hasRole(EmployeeRole.ClinicalSpecialist) &&
        !hasRole(EmployeeRole.RetrievalSurgeon) &&
        !hasRole(EmployeeRole.ClinicalLead),
      fields: { baseLocationId: null },
    },
    {
      condition: hasRole(EmployeeRole.ClinicalLead) && selectedRoles.length === 1,
      fields: { organType: [] },
    },
    {
      condition: !hasRole(EmployeeRole.ClinicalLead),
      fields: { phoneSupportOrganSpecializations: [] },
    },
    {
      condition: !hasRole(EmployeeRole.ScheduleManagerRs),
      fields: { rsScheduleManagerOrgans: [] },
    },
    {
      condition: !hasRole(EmployeeRole.OrganManagementSpecialist),
      fields: { organManagementSpecialistSpecializations: [] },
    },
    {
      condition: hasRole(EmployeeRole.OrganManagementSpecialist),
      fields: {
        organManagementSpecialistSpecializations: DEFAULT_OMS_ORGAN_SPECIALIZATIONS,
      },
    },
  ];
};
